import { TranslationKeys } from "../contexts/TranslationKeys";
import { Translator } from "../contexts/translator";
import { MultiSelectOption } from "./MultiSelectOption";

export const MusteringStatuses = (translate: Translator): MultiSelectOption[] => {
    return [
    {
        label: translate.byKey(TranslationKeys.absent),
        value: '1'
    },
    {
        label: translate.byKey(TranslationKeys.mustered),
        value: '2'
    },
    {
        label: translate.byKey(TranslationKeys.manuallyMustered),
        value: '3'
    },
    {
        label: translate.byKey(TranslationKeys.unaccounted),
        value: '4'
    },
    {
        label: translate.byKey(TranslationKeys.exited),
        value: '5'
    },
]};
